<template>
  <v-container>
    <v-flex>
      <application-details
        :application="application"
        :title="title"
        :subtitle="subtitle"
        :application-state-text="applicationStateText"
        :new-card-application="newCardApplication"
      />
    </v-flex>
  </v-container>
</template>

<script>
import {
  address,
  ApplicationStateTranslation,
  ApplicationTypeTranslation,
  dateFilter,
  DisplayApplicationState,
  DisplayApplicationType
} from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import ApplicationDetails from '@/components/application/Details';
import { config } from '@/utils/config';

// @vuese
// Komponent wyświetla szczegóły wniosku
// @group application
export default {
  components: { ApplicationDetails },
  filters: { address, date: dateFilter },
  data() {
    return {
      mediaURL: config.mediaURL,
      state: undefined,
      id: undefined,
      showModal: false,
      route: `/clients/${this.userId}`
    };
  },
  computed: {
    ...mapState({
      application: state => state.application.data,
      userId: state => state.application.data.profile.userId
    }),
    title() {
      return `Wniosek numer ${this.application.id}`;
    },
    subtitle() {
      return ApplicationTypeTranslation[DisplayApplicationType[this.application.type]];
    },
    applicationStateText() {
      return ApplicationStateTranslation[DisplayApplicationState[this.application.state]];
    },
    newCardApplication() {
      return this.application.type === 'NEW';
    }
  }
};
</script>
